import { render } from "./TheRechargesContainer.vue?vue&type=template&id=522e561e"
import script from "./TheRechargesContainer.vue?vue&type=script&lang=js"
export * from "./TheRechargesContainer.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__